import http from './http';

export default {
  all() {
    return http().get(`/v1/notifications`);
  },
  allForCategory(category, query = '') {
    return http().get(`/v1/notifications/category/${category}?` + query);
  },
  counts() {
    return http().get('/v1/notifications/counts');
  },
  get(id) {
    return http().get(`/v1/notifications/${id}`);
  },
  markRead(data) {
    return http().put(`/v1/notifications/${data.notification_id}/mark_read`, data);
  },
  delete(id) {
    return http().delete(`/v1/notifications/${id}`);
  },
  deleteAllForCategory(category) {
    return http().delete(`/v1/notifications/category/${category}`);
  },
}
